import { observable, action, computed } from 'mobx';
import { ViewController } from '@estee/elc-service';
import { LoadContentUseCase } from '../use-cases/LoadContentUseCase';
import { ContentRepository } from '../repositories/ContentRepository';
import { diContainer } from '../../service-setup/diContainer';
import serviceNames from '~setup/ContentService';
import { INodeContent } from '~domain/entities/Node';
import { IContentBlock } from '../../exported/content-block/ContentBlock';

export class ContentBlockViewController extends ViewController {
    @observable private contentRepository: ContentRepository;

    constructor() {
        super();
        this.contentRepository = diContainer.get(serviceNames.contentRepository);
    }

    @action
    public loaded = async (props: IContentBlock) => {
        const { nid } = props.config;
        this.isLoading = true;
        const loadContentUseCase = new LoadContentUseCase(nid, props.state);
        await loadContentUseCase.execute();

        this.isLoading = false;
    };

    @computed
    get data() {
        return {
            content: this.contentRepository.nodes
        };
    }

    public getContent(nid: number) {
        return <INodeContent | undefined>this.contentRepository.getContent(nid);
    }
}
